
/* eslint-disable no-restricted-syntax */
import { Component } from 'vue-property-decorator';
import KiosksTemplate from '@/components/kiosks/KiosksTemplate.vue';
import Graph from '@/components/Graphs';

@Component({
  components: {
    KiosksTemplate,
  },
})

export default class Map5 extends KiosksTemplate {
  availableKiosks = 5;

  optimalNrOfKiosks = 3;

  nrOfFields = 10;

  map = new Graph(this.nrOfFields);

  fields = [false, false, false, false, false, false, false, false, false, false];

  initGraph():void {
    for (let i = 0; i < this.nrOfFields; i += 1) {
      this.map.addVertex(i);
    }
    this.map.addEdge(1, 2);
    this.map.addEdge(3, 4);
    this.map.addEdge(4, 5);
    this.map.addEdge(8, 9);
    this.map.addEdge(0, 3);
    this.map.addEdge(1, 3);
    this.map.addEdge(1, 4);
    this.map.addEdge(2, 5);
    this.map.addEdge(2, 6);
    this.map.addEdge(3, 7);
    this.map.addEdge(3, 8);
    this.map.addEdge(4, 8);
    this.map.addEdge(5, 9);
    this.map.addEdge(6, 9);
  }
}
